import { GiftIcon, TruckIcon, VideoIcon } from 'lucide-react';
import { policyCopy } from '../../../data/policies';

/** Wat het abonnement oplevert — uit de instellingen, nooit met de hand. */
export function SubscriptionPerks({
  untilGift
}: {
  untilGift?: number;
}) {
  return <section aria-labelledby="perks-title" className="bg-sand p-5 sm:p-6" data-id="element-6155" data-mp="217i0h8hxnb0z">
      <h2 id="perks-title" className="text-[15px] text-ink" data-id="element-6156" data-mp="1w9q70a1n3guo">
        Wat je erbij krijgt
      </h2>
      <ul className="mt-3 space-y-2.5 text-[14px] leading-relaxed text-muted" data-id="element-6157" data-mp="2a8pz5rod2dvl">
        <li className="flex gap-2.5" data-id="element-6158" data-mp="267mk37e50lvf">
          <TruckIcon className="mt-0.5 h-4 w-4 shrink-0 text-clay" strokeWidth={1.5} aria-hidden="true" data-id="element-6159" data-mp="266l890parvcn" />
          Altijd zonder verzendkosten, ook bij één product.
        </li>
        <li className="flex gap-2.5" data-id="element-6160" data-mp="2f1j3wfjtxm7o">
          <GiftIcon className="mt-0.5 h-4 w-4 shrink-0 text-clay" strokeWidth={1.5} aria-hidden="true" data-id="element-6161" data-mp="2ty9tjx3pbjk3" />
          <span data-id="element-6162" data-mp="2oz5nvgfzk3yi">
            {policyCopy.subscriptionGift}.{untilGift !== undefined && untilGift > 0 && ` Nog ${untilGift === 1 ? 'één levering' : `${untilGift} leveringen`}.`}
          </span>
        </li>
        <li className="flex gap-2.5" data-id="element-6163" data-mp="19obstewdxl6n">
          <VideoIcon className="mt-0.5 h-4 w-4 shrink-0 text-clay" strokeWidth={1.5} aria-hidden="true" data-id="element-6164" data-mp="19peijjhz1hkz" />
          {policyCopy.videoChecks}.
        </li>
      </ul>
    </section>;
}